/**
 * Wrapper for web socket client.
 */

export default class WebSocketClient {

	constructor(port, address = 'localhost', reconnectInterval = 10000, autoReconnect = true) {
		this.connection = null;
		this.autoReconnect = autoReconnect;
		this.supportsWebsockets = true;
		if (!'WebSocket' in window) {
			this.supportsWebsockets = false;
			return;
		}

		this.port = port;
		this.connectionEstablished = false;
		this.onOpenLog = '...';
		this.address = address;
		this.reconnectInterval = reconnectInterval;
		this.reconnect = null;
		this.error = {
			occurred: false
		};
	}

	init(callbacks) {
		if (!this.supportsWebsockets) {
			return console.log('WebSocket is not supported.');
		}

		let onOpenCallback = callbacks.onOpen;
		let onMessageCallback = callbacks.onMessage;
		let onCloseCallback = callbacks.onClose;

		function client() {
			//
		}

		let address = this.address;
		let port = this.port;
		let context = this;

		client.prototype.start = function () {

			this.socket = new WebSocket('wss://' + address + ':' + port);
			this.emittingError = false;

			this.socket.onopen = (e) => {
				this.emittingError = false;
				if (typeof onOpenCallback == 'function') {
					return onOpenCallback(this.socket, e);
				}
			}

			this.socket.onmessage = (m) => {
				if (typeof onMessageCallback == 'function') {
					return onMessageCallback(this.socket, m);
				}
			}

			this.socket.onclose = (e) => {
				this.emittingError = true;
				if (context.autoReconnect == true) {
					this.reconnect(e, this, 5000);
					console.log('STATUS: Connection closed. Reconnecting.....');
				} else {
					console.log('STATUS: Connection halt');
				}

				if (typeof onCloseCallback == 'function') {
					return onCloseCallback(this.socket, e);
				}
			}
		}

		client.prototype.send = (data) => {
			this.socket.send(JSON.stringify(data));
		}

		client.prototype.reconnect = (e, instance, clientReconnectInterval = null) => {
			if (context.autoReconnect == true) {
				let newClientInstance = this;
				let reconnectInterval = context.reconnectInterval;
				if (clientReconnectInterval !== null) {
					reconnectInterval = clientReconnectInterval;
				}

				setTimeout(() => {
					instance.start();
				}, reconnectInterval);
			} else {
				console.log('STATUS: Reconnection halt.');
			}
		}

		return new client();
	}

	send(data) {
		this.connection.send(data);
	}

}